// libs
import React, { useEffect } from 'react'

// components

// helpers
import { useUser } from '@lopo-tech/lopo-api'
import { useChangeAppLocation } from 'src/actions/app-state/app-state_hooks'
import { useGetAppLocationShape } from 'src/reducers/app-state/app-state_hooks'
import { useSelectIsUserLoggedIn } from '../../../reducers/user/user_hooks'

export const LocationHandler: React.FC<React.PropsWithChildren<object>> = ({ children }) => {
  const locationShape = useGetAppLocationShape()
  const isLoggedIn = useSelectIsUserLoggedIn()
  const { data } = useUser({ skip: !isLoggedIn || !locationShape })
  const changeAppLocation = useChangeAppLocation()

  useEffect(() => {
    if (locationShape) return

    if (data?.currentProfile?.address.locationShape) {
      changeAppLocation(data.currentProfile.address.locationShape)
    }
  }, [
    data?.currentProfile?.address.locationShape,
    changeAppLocation,
    isLoggedIn
  ])

  return <>{children}</>
}

export default LocationHandler
